import { AccountLabel } from "@/entities/DataAssociation/Account.model";
import {
    CATEGORY_METADATA,
    LabelMetadata,
} from "../constants/labeling.constants";
import { LabelBase } from "./LabelBase";
import clsx from "clsx";
import { SparklesIcon } from "@heroicons/react/24/outline";

export function LabelItem({
    label,
    onClick,
    prettify = true,
    dot = false,
    listItem = false,
    className,
    recommended = false,
}: {
    prettify?: boolean;
    dot?: boolean;
    listItem?: boolean;
    label: LabelMetadata;
    onClick?: (labelCode: AccountLabel) => void;
    recommended?: boolean;
    className?: string;
}) {
    const text = prettify ? label.name : label.code;
    const color = label.category
        ? CATEGORY_METADATA[label.category].color
        : undefined;

    if (listItem) {
        return (
            <li
                className={clsx(
                    "card flex items-center justify-between gap-2",
                    recommended && "border-default mb-2 border",
                    className,
                )}
                key={label.name}
                onClick={() => {
                    onClick?.(label.code);
                }}
            >
                <LabelBase text={text} color={color} dot={dot} />
                {recommended && (
                    <SparklesIcon className="text-subdued size-4" />
                )}
            </li>
        );
    }

    return (
        <div onClick={() => onClick?.(label.code)} className={className}>
            <LabelBase text={text} color={color} dot={dot} />
        </div>
    );
}
